var UISelect = (function ($) {

    UISelect = function () {
        var that = this;

        // DOM

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UISelect.prototype.event_names = {
        open: 'select-open',
        close: 'select-close'
    };

    UISelect.prototype.close_select_timeout = 300;

    UISelect.prototype.scrollbar_theme = 'scrollbar';

    UISelect.prototype.class = {
        focus: 'focus',
        not_empty: 'not-empty',
        error: 'error',
        selected: 'selected',
        option: 'option',
        option_empty: 'option-empty',
        inputmode_none: 'js-inputmode-none'
    };

    UISelect.prototype.icons = {
        selected: '<i class="fab fa-sa-check"></i>',
        search: '<i class="fab fa-sa-search"></i>',
        clear: '<i class="fab fa-sa-x"></i>'
    };

    UISelect.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
        //
        that.prepareOptionsList();
        //
        that.__setupInputmode();

    };

    UISelect.prototype.__setupInputmode = function () {
        var that = this;

        $.sa.$document.find('.select .select-input input').each(function () {
            var $select_input = $(this);

            if ($.sa.is_mobile()) {
                that.__setInputmodeNone($select_input, true);
            } else {
                that.__setInputmodeNone($select_input, false);
            }
        });
    };
    
    /**
     *
     * @param {jQuery} $select_input
     * @param {boolean} set
     * @private
     */
    UISelect.prototype.__setInputmodeNone = function ($select_input, set) {
        var that = this;

        if (set === true) {
            if (!$select_input.hasClass(that.class.inputmode_none)) {
                if ($select_input.attr('inputmode')) {
                    $select_input.attr('data-inputmode', $select_input.attr('inputmode'));
                }
                $select_input.attr('inputmode', 'none');
                $select_input.addClass(that.class.inputmode_none);
            }
        }
        
        if (set === false) {
            if ($select_input.hasClass(that.class.inputmode_none)) {
                if ($select_input.attr('data-inputmode')) {
                    $select_input.attr('inputmode', $select_input.attr('data-inputmode'));
                    $select_input.removeAttr('data-inputmode');
                } else {
                    $select_input.removeAttr('inputmode');
                }
                $select_input.removeClass(that.class.inputmode_none);
            }
        }
    };

    UISelect.prototype.initEventHandlers = function () {
        const that = this;

        const focus_class = 'is-focused',
              focused_options = [];

        // Change inputmode for input depending on $window size
        $.sa.$window.on('resize', function (){
            that.__setupInputmode();
        });

        // Clicking anywhere in the select causes focus
        $.sa.$document.on('click', '.select .select-input', function (e) {
            var $target = $(e.target),
                $select_input_wrapper = $(this),
                $select_input = $select_input_wrapper.find('input');

            if (!$target.is('input') && !$select_input.is(':disabled') && !$select_input.is(':read-only')) {
                setTimeout(function () {
                    $select_input.focus();
                }, 150);
            }
        });

        // EVENT: Click (mouseup) to option
        // mouseup - huck for laptops with touchpads
        $.sa.$document.on('mouseup', '.select .option', function (e) {
            var $option = $(this),
                $select = $option.parents('.select');

            that._selectOption($select, $option);
        });

        // EVENT: focus
        $.sa.$document.on('focus', '.select .select-input input', function (e) {
            var $select_input = $(this),
                $select_input_wrapper = $select_input.parents('.select-input'),
                $select = $select_input_wrapper.parents('.select'),
                $select_hidden_input = $select.find('input[type=hidden]'),
                $select_options = $select.find('.select-options'),
                $select_options_list = $select_options.find('ul.list'),
                $select_option_items = $select_options.find('.option').filter(function () {
                    var $option = $(this);
                    return !$option.data('hidden');
                });
            
            if ($select_input.is(':read-only')) {
                e.preventDefault();
                return false;
            }

            if (!!$select_input.val()) {
                $select.addClass(that.class.not_empty);
            }

            if (!$select_options_list.find('.' + that.class.option_empty).length) {
                $select_options_list.append(that.__getEmptyOption($select_options_list.data('empty')));
            }

            if ($.sa.is_mobile()) {
                e.preventDefault();
                that._drawer_bottom_init($select, $select_option_items.length > 7);

                setTimeout(function () {
                    $select.trigger(that.event_names.open);
                }, 100);
                return false;
            } else {
                if ($select_hidden_input.val()) {
                    var $selected_option = $select_options.find('.option[data-value="' + $select_hidden_input.val() + '"]');
                    that._highlightOption($selected_option);
                }

                $select.addClass(that.class.focus);

                setTimeout(function () {
                    $select.trigger(that.event_names.open);
                    that.__initOptionsScroll($select_options);
                }, 100);
            }
        });

        // EVENT: blur
        $.sa.$document.on('blur', '.select .select-input input', function (e) {
            var $select_input = $(this),
                $select = $select_input.closest('.select'),
                $visible_options = $select.find('.select-options .option:visible');

            if ($select_input.val().length && $visible_options.length === 1) {
                that._selectOption($select, $($visible_options[0]));
            }

            setTimeout(function () {
                clean();
                that.__closeSelect($select);
            }, that.close_select_timeout);
        });

        // EVENT: input
        var timer = null;
        $.sa.$document.on('input', '.select .select-input input', function () {
            var $select_input = $(this),
                $select_input_wrapper = $select_input.parents('.select-input'),
                $select = $select_input_wrapper.parents('.select'),
                $select_hidden_input = $select.find('input[type=hidden]'),
                $error = $select_input_wrapper.find('.error'),
                $select_options = $select.find('.select-options'),
                $select_options_list = $select_options.find('ul.list');

            // Discard value from hidden input on every input
            if ($select_input.is(':focus')) {
                $select.addClass(that.class.focus).trigger(that.event_names.open);
            }
            $select_hidden_input.val('');
            $select_options_list.find('.option').removeClass(that.class.selected);
            $select_options_list.find('svg').remove();

            // Drop errors
            $error.text('');
            $select.removeClass(that.class.error).toggleClass(that.class.not_empty, !!$select_input.val());

            timer && clearTimeout(timer);
            timer = setTimeout(function () {
                that.__filterOptions($select.find('.list'), $select_input.val());
            }, 100);
        });

        // EVENT: external direct change
        $.sa.$document.on('change', '.select input[type=hidden]', function () {
            var $select_hidden_input = $(this),
              value = $select_hidden_input.val(),
              $select = $select_hidden_input.parents('.select').first(),
              $select_options = $select.find('.select-options ul.list li.option'),
              changed = false,
              $matched = $select_options.filter(function () {
                  var $option = $(this),
                    _value = $option.data('value'),
                    matched = _value === value;

                  if (matched && !$option.hasClass(that.class.selected)) {
                      changed = true;
                  }

                  return matched;
              }).first();

            $select_options.removeClass(that.class.selected);

            if (changed) {
                that.__clearValue($select);
                if ($matched.length) {
                    that._selectOption($select, $matched);
                }
            }
        });

        $.sa.$document.on('keydown', '.select .select-input input', onKeyDown);

        //

        function onKeyDown(event) {
            var $select_input = $(this),
                $select = $select_input.closest('.select'),
                $select_hidden_input = $select.find('input[type=hidden]'),
                is_arrow_up = (event.keyCode === 38),
                is_arrow_down = (event.keyCode === 40),
                is_enter = (event.keyCode === 13 || event.keyCode === 10),
                is_escape = (event.keyCode === 27),
                is_backspace = (event.keyCode === 8);

            if (!$select &&
                !is_arrow_up &&
                !is_arrow_down &&
                !is_enter
            ) {
                return;
            }

            is_arrow_down && onPressNext();
            is_arrow_up && onPressPrev();
            is_enter && onPressEnter();
            is_escape && onPressEscape();
            is_backspace && onPressBackspace();

            // Functions

            function onPressEnter() {
                // Если внутри формы, то отключаем нативный триггер сабмита форрмы
                const is_form = event.target.closest('form');
                if (is_form) {
                    event.preventDefault();
                }

                // Если select закрыт, то триггерим открытие
                if (!that.isFocused($select)) {
                    $select_input.trigger('focus');
                    return false;
                }

                // Если открыт, то ищем выбранный пункт и устанавливаем его
                let $option = $select.find('.option.' + focus_class);
                if (!$option.length) {
                    // Если виден один пункт -- выберем его, даже если он не в фокусе
                    var $visible_options = $select.find('.option:visible');
                    if ($select_input.val() && $visible_options.length === 1) {
                        $option = $($visible_options[0]);
                    }
                }

                if (!$option.length) { return false; }

                clean();
                that._selectOption($select, $option);
            }

            function onPressEscape() {
                that.__closeSelect($select);
            }

            function onPressNext() {
                focusOnOption(true);
            }

            function onPressPrev() {
                focusOnOption(false);
            }

            function onPressBackspace() {
                if ($select_input.val() && $select_hidden_input.val()) {
                    that.__clearValue($select);
                }
            }
            
            /**
             * @param {Boolean} next
             * */
            function focusOnOption(next = true) {
                let $target_option = getTargetOption();
                if (!$target_option.length) { return false; }

                clean();

                $target_option.trigger('focus').addClass(focus_class);
                $target_option[0].scrollIntoView({ block: 'nearest' });

                registerFocusedOption($target_option);

                /**
                 * @return {jQuery}
                 * */
                function getTargetOption() {
                    let result = null;

                    const $focused_option = $select.find('.option.'+ focus_class +':visible');
                    if ($focused_option.length) {
                        result = (next ? 
                            $focused_option.nextAll(':visible').first() :
                            $focused_option.prevAll(':visible').first()
                        );
                    } else {
                        const $visible_options = $select.find('.option:not(.'+ that.class.option_empty +'):visible');
                        result = (next ? $visible_options.first() : $visible_options.last());
                    }

                    return result;
                }
            }

            function registerFocusedOption($option, register = true) {
                const option = $option[0],
                      index = focused_options.indexOf(option),
                      is_added = (index >= 0);

                if (register) {
                    if (!is_added) {
                        focused_options.push(option);
                    }
                } else if (is_added) {
                    focused_options.splice(index, 1);
                }
            }
        }

        function clean() {
            // Очищаем все опции от фокус-класса
            focused_options.forEach( option => {
                $(option).removeClass(focus_class);
            });
            // Очищаем массив
            focused_options.splice(0, focused_options.length - 1);
        }
    };

    UISelect.prototype.__closeSelect = function ($select) {
        var that = this,
            $select_hidden_input = $select.find('input[type=hidden]'),
            $select_input = $select.find('.select-input input'),
            $select_options = $select.find('.select-options'),
            $select_options_list = $select_options.find('ul.list'),
            $visible_options = $select_options_list.find('.option:visible');

        if ($select_hidden_input.length && !$select_hidden_input.val()) {
            $select.removeClass(that.class.not_empty);
            $select_input.val('');
        }

        $select.removeClass(that.class.focus);
        that.__filterOptions($select_options_list, '');
        that.__destroyOptionsScroll($select_options);
        $select.trigger(that.event_names.close);
    };

    UISelect.prototype.prepareOptionsList = function () {
        var that = this;

        $.sa.$document.find('.select .select-input input').map(function () {
            var $select_input = $(this),
                $select_input_wrapper = $select_input.parents('.select-input'),
                $select = $select_input_wrapper.parents('.select'),
                $select_options = $select.find('.select-options'),
                $select_options_list = $select_options.find('ul.list');

            setTimeout(function () {
                that.__filterOptions($select_options_list, '');
            }, 50);
        });
    }

    /**
     * Передаем на вход массив { value: '', label: '' }[]
     */
    UISelect.prototype.makeOptionsFromArray = function ($select, array = []) {
        var $select_options = $select.find('.select-options'),
            $select_options_list = $select_options.find('ul.list');
        
        var html = array.map(function (option) {
            return `
                <li class="option" data-value="${option.value}">
                    <div class="label">${option.label}</div>
                </li>
            `;
        }).join('');

        $select_options_list.html(html);
    }

    // Common methods

    UISelect.prototype._highlightOption = function ($option) {
        if (!$option.length) {
            return false;
        }

        var that = this,
            $sub = $option.find('.sub'),
            $select_options = $option.parents('.select-options'),
            $select_options_list = $select_options.find('ul.list');

        $select_options_list.find('.option').removeClass(that.class.selected);
        $select_options_list.find('svg').remove();

        $option.addClass(that.class.selected);
        if (!$sub.length) {
            $option.append(that.icons.selected);
        }
    }
    
    UISelect.prototype.selectOption = function ($select, $option) {
        var that = this;
        
        that._selectOption($select, $option);
    };

    UISelect.prototype._selectOption = function ($select, $option) {
        var that = this,
            $label = $option.find('.label'),
            $select_input_wrapper = $select.find('.select-input'),
            $select_input = $select_input_wrapper.find('input'),
            $select_hidden_input = $select.find('input[type=hidden]'),
            $select_options = $select.find('.select-options'),
            $select_options_list = $select_options.find('ul.list');

        if ($option.hasClass(that.class.option_empty)) {
            return false;
        }

        that._highlightOption($option);

        $select_input.val($label.text());
        $select_hidden_input
            .val($option.data('value'))
            .change()
            .trigger('input');

        $select
            .removeClass(that.class.error)
            .removeClass(that.class.focus)
            .toggleClass(that.class.not_empty, !!$select_input.val())
            .trigger(that.event_names.close);

        that.__filterOptions($select_options_list, '');

        $select.trigger('change', {value: $.trim($select_input.val())});
    }

    UISelect.prototype.__filterOptions = function ($select_options_list, query) {
        query = $.trim(query);
        
        var that = this,
            query_escaped = [
                $.sa.escapeRegExp($.sa.swapLetters(query, true)),
                $.sa.escapeRegExp($.sa.swapLetters(query))
            ].join('|'),
            filter = new RegExp(query_escaped, 'ui'),
            empty_query = query.length === 0,
            $options = $select_options_list.find('.' + that.class.option).not('.' + that.class.option_empty),
            $option_empty = $select_options_list.find('.' + that.class.option_empty) || '';

        $options.each(function () {
            var $option = $(this),
                option_is_hidden = !!$option.data('hidden');

            if (option_is_hidden) {
                $option.hide();
            } else {
                var $label = $option.find('.label').first(),
                    label_text = '' + $label.text() || '';

                if (empty_query) {
                    $label.html(label_text);
                    $option.show();
                } else {
                    var scope = [
                        label_text,
                        '' + $option.find('.sub').first().text() || '',
                        '' + $option.data('value') || '',
                        '' + $option.data('search') || '',
                    ].map(function (value) {
                        return (value && value.length) ? $.sa.pregMatch(filter, value) : false;
                    });

                    if (scope.filter(item => !!item).length) {
                        if (scope[0]) {
                            // Only label! sub does not need a highlight.
                            $label.html(label_text.replace(filter, '<span class="highlighted">' + $('<div />').text(scope[0]).html() + '</span>'));
                        } else {
                            $label.html(label_text);
                        }

                        $option.show();
                    } else {
                        $option.hide();
                    }
                }
            }
        });

        var options_visible_count = $options.filter(':visible').length;
        if (options_visible_count < 1 && !empty_query) {
            $option_empty.show();
        } else {
            $option_empty.hide();
        }
    }

    UISelect.prototype.clearValue = function ($select, focus = false) {
        var that = this;
        
        that.__clearValue($select, focus);
    }

    UISelect.prototype.__clearValue = function ($select, focus = false) {
        var that = this,
            $select_input = $select.find('.select-input input'),
            $select_hidden_input = $select.find('input[type=hidden]'),
            $select_options = $select.find('.select-options'),
            $select_options_list = $select_options.find('ul.list');

        $select_options_list.find('.option').removeClass(that.class.selected);
        $select_options_list.find('svg').remove();

        if ($select_input.is(':focus')) {
            $select.addClass(that.class.focus).trigger(that.event_names.open);
        }
        $select_input.val('');
        $select_hidden_input.val('').change();

        $select.removeClass(that.class.not_empty);

        if (focus) {
            $select_input.focus();
        }
    }

    UISelect.prototype.__disabled = function ($select, disabled = true) {
        var $select_input = $select.find('.select-input input');

        $select_input.attr('disabled', disabled);
    }

    UISelect.prototype.__initOptionsScroll = function ($select_options, scrollbar_options = {}) {
        var $select_options_list = $select_options.find('ul.list');

        $.uiScrollbar($select_options_list, null, scrollbar_options);
    };

    UISelect.prototype.__destroyOptionsScroll = function ($select_options) {
        var $select_options_list = $select_options.find('ul.list'),
            ui_scrollbar = $select_options_list.data('uiScrollbar');
        
        if (ui_scrollbar) {
            ui_scrollbar.destroy();
        }
    };

    //

    UISelect.prototype.__getEmptyOption = function (label) {
        var that = this;

        //
        var empty_option = document.createElement('li');
        empty_option.classList.add(that.class.option, that.class.option_empty);
        empty_option.style.display = 'none';

        var empty_option_label = document.createElement('div');
        empty_option_label.classList.add('label');
        empty_option_label.innerHTML = label || $.sa.locales['select_search_empty'];
        empty_option.append(empty_option_label);

        return empty_option;
    }

    // Methods prefixed with _drawer_bottom_ apply only to mobile select elements with options <= 7 options

    UISelect.prototype._drawer_bottom_init = function ($select, fullscreen = false) {
        if ($select.data('drawer_bottom')) {
            return;
        }

        var that = this,
            $placeholder = $select.find('.placeholder'),
            $select_input_wrapper = $select.find('.select-input'),
            $select_input = $select_input_wrapper.find('input'),
            $select_hidden_input = $select.find('input[type=hidden]'),
            $select_options_raw = $select.find('.select-options'),
            $select_options_clone = $select_options_raw.clone(true),
            $select_options_list_clone = $select_options_clone.find('.list');

        if ($select_hidden_input.val()) {
            var $selected_option = $select_options_clone.find('.option[data-value="' + $select_hidden_input.val() + '"]');
            that._highlightOption($selected_option);
        }

        $select_input.blur();

        $select_options_clone.on('click', '.option', function () {
            var $option = $(this);
            that._selectOption($select, $option);
            if ($select.data('drawer_bottom')) {
                $select.data('drawer_bottom').close();
            }
        });

        var $content = $('<div />').addClass('select-drawer-content');
        if (fullscreen) {
            var $search_icon = $('<span />').addClass('icon-search').append(that.icons.search),
                $search_input = $('<input />').addClass('select-fullscreen-search-input').addClass('js-search').attr('placeholder', $.sa.locales.search).attr('type', 'text').attr('autocomplete', 'off'),
                $search_close_icon = $('<a />').hide().addClass('icon-clear').addClass('js-clear').attr('href', 'javascript:void(0);').append(that.icons.clear),
                $search_input_wrapper = $('<div />').addClass('select-fullscreen-search-input-wrapper').append($search_icon).append($search_input).append($search_close_icon),
                $search = $('<div />').addClass('select-fullscreen-search').append($search_input_wrapper);

            var timer = null;
            $search_input
                .on('input keydown', function (e) {
                    var is_enter = (e.keyCode === 13 || e.keyCode === 10),
                        $visible_options = $select_options_list_clone.find('.option:visible');

                    if (is_enter && $search_input.val().length && $visible_options.length === 1) {
                        that._selectOption($select, $($visible_options[0]));
                        if ($select.data('drawer_bottom')) {
                            $select.data('drawer_bottom').close();
                        }
                    }

                    timer && clearTimeout(timer);
                    timer = setTimeout(function () {
                        var search_value = $search_input.val();
                        that.__filterOptions($select_options_list_clone, search_value);
                        if (search_value.length) {
                            $search_input_wrapper.addClass(that.class.not_empty);
                            $search_close_icon.show();
                        } else {
                            $search_input_wrapper.removeClass(that.class.not_empty);
                            $search_close_icon.hide();
                        }
                    }, 100);
                })
                .on('focus', function () {
                    $search_input_wrapper.addClass(that.class.focus);
                    $select.trigger(that.event_names.open);
                })
                .on('blur', function () {
                    $select.trigger(that.event_names.close);
                    setTimeout(function () {
                        $search_input_wrapper.removeClass(that.class.focus);
                    }, that.close_select_timeout);
                });

            $search_close_icon.on('click', function () {
                that.__filterOptions($select_options_list_clone, '');
                $search_close_icon.hide();
                $search_input_wrapper.removeClass(that.class.not_empty);
                $search_input.val('').focus();
            });

            $content.append($search);
        }
        $content.append($select_options_clone);

        setTimeout(function () {
            var drawer_bottom = $.uiDrawerBottom({
                fullscreen: fullscreen,
                header_contrast: true,
                header: $placeholder.text(),
                content: $content,
                onBgClick: function (drawer_bottom) {
                    drawer_bottom.close();
                },
                onOpen: function () {
                    setTimeout(function () {
                        that.__initOptionsScroll($select_options_clone);
                    }, 100);
                },
                onClose: function () {
                    $select_input.blur();
                    $select.data('drawer_bottom', null);
                }
            })
            $select.data('drawer_bottom', drawer_bottom);
        }, 150);
    }

    UISelect.prototype.isFocused = function ($select) {
        const that = this;
        return $select.hasClass(that.class.focus);
    }

    return UISelect;
})($);
